module.exports = __webpack_public_path__ + "static/media/gallery-1.36212b00.png";